import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from 'react-toastify';
const BASE_URL = process.env.REACT_APP_MAIN_URL

export const GetUsers = createAsyncThunk(
//   "user/GetUsers",
//   async () => {
//     const { data } = await coreAxios.get('/user/list/');
//     return data
//   }
  "user/GetUsers",
  async () => await (await axios.get(`${BASE_URL}/api/user/list/`)).data
);

export const SignUp = createAsyncThunk(
  "user/SignUp",
  // async (values) => await (await axios.post(`${BASE_URL}/registration/`, values)).data
    async (values) => {
    const { data } = await axios.post(`${BASE_URL}/api/registration/`, values);
    console.log("data: ", data)
    return data
  }
);

export const UpdateUser = createAsyncThunk(
  "user/UpdateUser",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/user/update/${data.id}/`, data)
    return response.data
  }
);

export const DeletePost = createAsyncThunk(
  "post/deletePost",
  async (post) => await (await axios.post(`${BASE_URL}/post`, post)).data
);

export const GetUnits = createAsyncThunk(
  "user/GetUnits",
  async () => await (await axios.get(`${BASE_URL}/api/unit/list/`)).data
);

export const GetUserInfo = createAsyncThunk(
  "user/GetUserInfo",
  async (data) => {
    const response = await coreAxios.get(`${BASE_URL}/api/user/account/${data.emp_code}/`)
    return response.data
  }
);

export const UpdatePassword = createAsyncThunk(
  "user/UpdatePassword",
  async (payload, thunkAPI) => {
    try{
      const response = await coreAxios.put(`${BASE_URL}/api/update-password/`, payload)
      return response.data
    }catch(error){
      if (error.response && error.response.status === 400) {
        
        toast.error(error.response?.data?.message)
        // Handle the 400 error here
        return error?.response?.data
        // return thunkAPI.rejectWithValue(error.response?.data?.message);
      } else {
        return thunkAPI.rejectWithValue('Something went wrong');
      }
    }
  }
);